import React from 'react'

const PageLoader = () => (
	<div className="page-loader">
		<em className="fas fa-circle-notch fa-spin fa-3x text-muted"></em>
	</div>
)

export default PageLoader
